import { Menu, MenuProps } from 'antd';
import Sider from 'antd/es/layout/Sider';
import React, { useState } from 'react';
import {
  AppstoreOutlined,MessageOutlined
} from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import './SiderMenu.scss';
import {
  chatPath,
  devicesPath,
} from '../../routes';

type MenuItem = Required<MenuProps>['items'][number];

function getItem(label: React.ReactNode, key: React.Key, icon?: React.ReactNode, children?: MenuItem[]): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}

const SiderMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [collapsed, setCollapsed] = useState(false);
  let isDropdownClicked = false;

  const [selectedKey, setSelectedKey] = useState<string>(location.pathname.split('/').filter(Boolean).pop() || '');
  const handleMenu: MenuProps['onClick'] = (e) => {
    if (isDropdownClicked) return;
    setSelectedKey(e.key);
    navigate(`/dashboard/${e.key}`);
  };

  const menuItems = [
    getItem('Dispositivos', devicesPath, <AppstoreOutlined />),
    getItem('Chat IA', chatPath, <MessageOutlined />),
  ];

  return (
    <Sider
      className={'SiderMenu'}
      theme="light"
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
    >
      <Menu
        theme="light"
        mode="inline"
        items={menuItems}
        onClick={handleMenu}
        selectedKeys={[selectedKey]}
        className="DashboardMenu"
      />
    </Sider>
  );
};

export default SiderMenu;
